// All content data for Naqaab Filmmaking Club website

export const FILMS = [
  {
    id: 1,
    title: "Mannpasand",
    status: "In Production",
    genre: "Drama / Supernatural",
    team: 35,
    synopsis: "A shy teen discovers the power to make anyone obey him — and uses it to win his crush. But as he lives his dream, one question haunts him: is her love real?",
    color: "#c9a84c",
  },
  {
    id: 2,
    title: "Superstar",
    status: "Post-Production",
    genre: "Drama",
    team: 10,
    synopsis: "Anirudh rediscovers his passion for acting after finding a postcard from his late father — a reminder that it's never too late to chase your dreams.",
    color: "#1de0cc",
  },
  {
    id: 3,
    title: "Cross Roads",
    status: "Post-Production",
    genre: "Romance",
    team: 12,
    synopsis: "Siya and Ayaan navigate love, fear, fate, and second chances at the intersection of their lives.",
    color: "#c9a84c",
  },
  {
    id: 4,
    title: "20 Minutes",
    status: "Completed",
    genre: "Drama / Thriller",
    team: 10,
    synopsis: "Twenty minutes. Arjun. Betrayal, regret, and a mistake he can never take back.",
    color: "#c0392b",
  },
  {
    id: 5,
    title: "Two Birds, One Stone",
    status: "Completed",
    genre: "Thriller",
    team: 13,
    synopsis: "Two officers answer a noise complaint. What they find unravels a revenge decades in the making.",
    color: "#1de0cc",
  },
  {
    id: 6,
    title: "Shall We?",
    status: "Released",
    genre: "Short / Social",
    team: 9,
    synopsis: "A Swachh Bharat Abhiyan film exploring civic duty — aligning with UN SDGs 11, 12, and 13.",
    color: "#c9a84c",
  },
];

export const PAST_EVENTS = [
  { name: "10-Day Filmmaking Challenge", date: "Jan 20-29, 2026", description: "69 participants, 10-day sprint to shoot a film on MIT campus", category: "Competition" },
  { name: "Republic Day Special", date: "Jan 26, 2026", description: "77 images, one India story — a tribute video for India's 77th Republic Day", category: "Content" },
  { name: "Spin The Scene", date: "Dec 30-31, 2025", description: "Short film challenge — spin for object + reference film, create in 1 day", category: "Competition" },
  { name: "Online Workshops", date: "Dec 8-15, 2025", description: "Screenwriting, Cinematography, Editing, Sound Design", category: "Workshop" },
  { name: "Swachh Bharat Abhiyan", date: "Oct 3, 2025", description: "Short film 'Shall We?' — 9 members, SDG-aligned content", category: "Social Impact" },
  { name: "Movie Screening — Superstar", date: "Sep 24, 2025", description: "Private premiere of Naqaab's short film at MV Seminar Hall", category: "Screening" },
  { name: "Teachers' Day Video", date: "Sep 5, 2025", description: "Heartfelt tribute video with faculty interviews on campus", category: "Content" },
  { name: "TEDx MAHE Collaboration", date: "Aug 23-24, 2025", description: "Behind-the-scenes coverage for 'Portrait of a Mind' event", category: "Collab" },
  { name: "SP Infodesk / Recruitment", date: "Aug 18-23, 2025", description: "Booth at Student Plaza — crosswords, photo booth, karaoke, film screenings", category: "Outreach" },
  { name: "Board Transfer Ceremony", date: "Aug 3, 2025", description: "Handover from outgoing to new executive board at KEF R&D Centre", category: "Internal" },
  { name: "MCH Dastaan Competition", date: "Mar 22, 2025", description: "5-hour short film contest — theme 'Stories within Stories' — 1st Place", category: "Achievement" },
  { name: "10-Day Filmmaking Challenge", date: "Jan 20-30, 2025", description: "78 participants, theme 'No Fear is Small', Screening Feb 1", category: "Competition" },
];

export const NAQAAB_PICKS = [
  { film: "Superman", date: "Jul 16, 2025", poster: "https://image.tmdb.org/t/p/w500/dnp5RWRnFMqEWOhj3cUHgUqFbbE.jpg" },
  { film: "Fantastic Four", date: "Jul 26, 2025", poster: "https://image.tmdb.org/t/p/w500/4bZ2GEz2tXyZr7NOZmJhmYv7TE3.jpg" },
  { film: "Weapons", date: "Aug 10, 2025", poster: "https://images.unsplash.com/photo-1535016120720-40c646be5580?q=80&w=400&auto=format&fit=crop" },
  { film: "Kingdom", date: "Aug 12, 2025", poster: "https://images.unsplash.com/photo-1519904981063-b0cf448d479e?q=80&w=400&auto=format&fit=crop" },
  { film: "Coolie", date: "Aug 16, 2025", poster: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?q=80&w=400&auto=format&fit=crop" },
  { film: "War 2", date: "Aug 24, 2025", poster: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?q=80&w=400&auto=format&fit=crop" },
  { film: "Dhurandhar", date: "Dec 15, 2025", poster: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=400&auto=format&fit=crop" },
  { film: "Bhay: The Gaurav Tiwari Mystery", date: "Dec 29, 2025", poster: "https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=400&auto=format&fit=crop" },
  { film: "Homebound", date: "Dec 30, 2025", poster: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?q=80&w=400&auto=format&fit=crop" },
  { film: "Pluribus", date: "Dec 31, 2025", poster: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=400&auto=format&fit=crop" },
  { film: "Avatar: Fire and Ash", date: "Jan 1, 2026", poster: "https://image.tmdb.org/t/p/w500/sJCzEMVmJOQCZaOgUfPgaHLqaKI.jpg" },
];

export const BOARD_MEMBERS = [
  {
    name: "Akash Shaw",
    role: "President",
    group: "Board",
    quote: "As alive as Schrodinger's cat",
    films: ["3 Idiots", "Interstellar", "Shutter Island"],
  },
  {
    name: "Kumar Abhishek",
    role: "Vice President & Screenwriting Head",
    group: "Board",
    quote: "Mr. Kumar is the greatest person to ever grace the face of this earth — The New York Times",
    films: ["Silence", "Into the Wild", "Om Shanti Om"],
  },
  {
    name: "Navya Mamgain",
    role: "General Secretary",
    group: "Board",
    quote: "Why so serious?",
    films: ["Eternal Sunshine of the Spotless Mind", "Rang De Basanti", "12 Angry Men"],
  },
  {
    name: "Nidhi Vernekar",
    role: "Treasurer & Outstation & Management Head",
    group: "Board",
    quote: "Aap Thank You mat boliye... bas mera cv 3 companies ko forward kar dijiye",
    films: ["Bhool Bhulaiyaa", "Piku", "Bulbbul"],
  },
];

export const CREATIVE_MEMBERS = [
  {
    name: "Akash Shaw",
    role: "Cinematography & Editing Head",
    group: "Creative & Production",
    quote: "In the end we only regret the chances we did not take",
    films: ["Breaking Bad", "Chernobyl", "Better Call Saul"],
  },
  {
    name: "Rishit Kumar",
    role: "Cinematography & Editing / Sound Production Head",
    group: "Creative & Production",
    quote: "Jinke ghar sheeshe ke hote hai na... woh basement me kapde badalte hai",
    films: ["Golmaal 3", "1917", "How to Train Your Dragon"],
  },
  {
    name: "S. Snehita",
    role: "Screenwriting Head",
    group: "Creative & Production",
    quote: "Ek pyaara Goan main fasaaun",
    films: ["Socha Na Tha", "Swades", "Hi Nanna"],
  },
];

export const MANAGEMENT_MEMBERS = [
  {
    name: "Parth Niraj Kumar",
    role: "HR Head",
    group: "Management & Operations",
    quote: "Mujhe ghar jana hai",
    films: ["Scott Pilgrim vs. The World", "Me and Earl and the Dying Girl"],
  },
  {
    name: "Rahul Dhage",
    role: "HR Head",
    group: "Management & Operations",
    quote: "Dare hue log aksar alfazon ke peeche chhupte hai",
    films: ["Belle", "Sooryavansham"],
  },
  {
    name: "Deep Shetty",
    role: "Outstation & Management Head",
    group: "Management & Operations",
    quote: "Har Pal Yaha Ji Bhar Jiyo!!!",
    films: ["Kal Ho Naa Ho", "Phir Hera Pheri", "Tamasha"],
  },
  {
    name: "Srinivas Chakrala",
    role: "Marketing Head",
    group: "Management & Operations",
    quote: "Violence is the most fun thing to watch",
    films: ["Crimson Tide", "Kill Bill", "Gangs of Wasseypur"],
  },
  {
    name: "Adith Nair",
    role: "Marketing Head",
    group: "Management & Operations",
    quote: "Never let them know your next move.",
    films: ["The Shawshank Redemption", "Dangal", "Train to Busan"],
  },
];

export const TICKER_FILMS = [
  "SUPERSTAR", "CROSS ROADS", "20 MINUTES", "TWO BIRDS ONE STONE", "MANNPASAND", "SHALL WE?"
];

export const WORKSHOP_DATA = [
  { name: "Screenwriting Workshop", facilitator: "Kumar Abhishek / S. Snehita", date: "Dec 8, 2025" },
  { name: "Cinematography Workshop", facilitator: "Akash Shaw / Rishit Kumar", date: "Dec 10, 2025" },
  { name: "Editing Workshop", facilitator: "Akash Shaw / Rishit Kumar", date: "Dec 12, 2025" },
  { name: "Sound Design Workshop", facilitator: "Rishit Kumar", date: "Dec 15, 2025" },
];

export const COMPETITION_DATA = [
  { name: "10-Day Filmmaking Challenge", theme: "Open Theme", deadline: "Jan 29, 2026", teamSize: "6-8", prize: "Trophies + Certificates" },
  { name: "Spin The Scene", theme: "Random Object + Reference Film", deadline: "Dec 31, 2025", teamSize: "1-4", prize: "Bragging Rights" },
  { name: "MCH Dastaan", theme: "Stories within Stories", deadline: "Completed — 1st Place", teamSize: "3", prize: "1st Place Trophy" },
  { name: "India Film Project (IFP)", theme: "TBA", deadline: "Upcoming", teamSize: "Varies", prize: "National Recognition" },
];

export const DEMO_CREDENTIALS = {
  member: { id: "member", password: "naqaab2025", role: "member" },
  board: { id: "board", password: "naqaab#board", role: "board" },
};

export const MOCK_SUBMISSIONS = [
  { name: "Arjun Mehta", regNo: "230912345", dept: "CSE", year: "2nd", email: "arjun.mitmpl2023@learner.manipal.edu", phone: "+91 98765 43210", interests: ["Cinematography", "Editing"], reason: "I've always been fascinated by visual storytelling and want to learn from the best." },
  { name: "Priya Sharma", regNo: "230956789", dept: "ECE", year: "1st", email: "priya.mitmpl2024@learner.manipal.edu", phone: "+91 87654 32109", interests: ["Screenwriting", "Direction"], reason: "Cinema is my escape. I want to create worlds that others can escape into." },
  { name: "Rohan Gupta", regNo: "230934567", dept: "IT", year: "3rd", email: "rohan.mitmpl2022@learner.manipal.edu", phone: "+91 76543 21098", interests: ["Sound Design", "Acting"], reason: "Sound makes or breaks a film. I want to master it." },
];
